import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import { IMetaTags, IgetMetaTagsByFilters } from './types';

type TgetIndustryMetaTags = Pick<IgetMetaTagsByFilters, 'profileType' | 'industry'>;

export const getPossibleIndustryMetaTags = ({ profileType, industry }: TgetIndustryMetaTags): IMetaTags => {
  if (profileType === ProfileTypes.INDUSTRY) {
    const industryName = industry.metaTitleName;

    if (industry.subindustryId) {
      return metaTags.getIndustrySubindustryProfile(industryName);
    }

    return metaTags.getIndustryProfile(industryName);
  }

  return null;
};
